/* hemera-cartes.js — ajout au panier depuis la carte produit (14/10/2026).
   Ajoute 1 article, puis déclenche « product:added » : le mini-panier s'ouvre (avec l'avis « minimum de commande »). */
(function () {
  if (window.hemeraCartes) return;
  window.hemeraCartes = true;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hcp-ajout]');
    if (!b || b.disabled) return;
    e.preventDefault();
    b.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-hcp-ajout')), quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () {
        b.classList.add('est-ajoute');
        document.documentElement.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { quantity: 1 } }));
        setTimeout(function () { b.classList.remove('est-ajoute'); b.disabled = false; }, 1200);
      })
      .catch(function () {
        b.disabled = false;
        alert('Ce produit n\'a pas pu être ajouté au panier. Réessayez ou appelez-nous au 01 80 88 20 72.');
      });
  });
})();
